@if (visible) {
  <div class="fixed bottom-5 right-5 z-[2000]">
    <div [ngClass]="{
    'bg-blue-800': type === 'info',
    'bg-green-600': type === 'success',
    'bg-yellow-600': type === 'warning',
    'bg-red-800': type === 'error'
  }" class="text-white px-3 py-2 rounded-lg shadow-lg flex items-center gap-3 w-auto max-w-xs">
      <div>
        <strong class="block text-lg font-semibold">{{ localizedTitle}} </strong>
        <span class="text-sm">{{ localizedMsg }}</span>
      </div>
    </div>
  </div>
}
